export const API_URL_AUTH_STEAM = "/auth/steam";
export const API_URL_AUTH_LOGOUT = "/auth/logout";
export const API_URL_AUTH_EMAIL = "/auth/email";
export const API_URL_EMAIL_CONFIRM = "/auth/email/confirm";
export const API_URL_TRADE_URL = "/auth/trade-url";
export const API_URL_USER = "/user";
export const API_URL_PROFILE = "/user/profile";
export const API_URL_FEEDBACK = "/feedback";
